export default __webpack_public_path__ + "static/media/warning--low-ground-clearance--g1.ffa6da01.png";